import { styled } from 'styled-components';
import { lighten } from 'polished';

interface StyledHeaderProps {
  $backgroundColor: string;
}

const StyledHeader = styled.div<StyledHeaderProps>`
  background-image: ${(props) => `linear-gradient(45deg, ${props.$backgroundColor}, ${lighten(0.25, props.$backgroundColor)})`};
  height: 90px;
  padding: 18px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .left-content {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 18px;
  }
`;

export default StyledHeader;
